import styled from 'styled-components';
import color from 'tinycolor2';
import { Button } from '@pearsontechnology/aero-components';

export const Header = styled.header`
  padding: 30px 40px;
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  position: relative;

  @media (max-width: ${(props) => props.theme['media.mobile']}px) {
    padding: 10px 10px 30px 10px;
  }
`;

export const LineBreakContainer = styled.div`
  padding-left: 40px;
  padding-right: 40px;
  margin-top: -20px;
  margin-bottom: 40px
`;

export const LineBreak = styled.hr`
  background:  ${(props) => props.theme['themeId'] === 'dark' ? 
    color(props.theme['color.white']).setAlpha(0.2).toString() :
    color(props.theme['color.sidebar.focus.text']).setAlpha(0.2).toString()};
  height: 2px ;
  width : 100%;
`;

export const HeaderActions = styled.span`
  display: inline-flex;
  align-self: flex-start;
  align-items: center;
  margin-left: auto;

  & > * {
    margin-left: 18px;
  }
`;

export const Title = styled.span`
  font-size: 20px;
  color: ${(props) => props.theme['color.text.body']};
  white-space: pre-line;
  ${(props) => props.workspaceRedesign 
    && `font-size: 24px;font-weight: 300;
    ${props.theme['themeId'] === 'dark' 
    ? `color: ${props.theme['color.text.title']}` : `color: ${props.theme['color.sidebar.focus.text']}`}`}
`;

export const UpdatedTitle = styled.span`
font-size: 24px;
white-space: pre-line;
font-weight: 300;
line-height: 28px;
font-style: normal;
color: ${(props) =>
    props.theme.themeId === 'dark'
      ? props.theme['color.text.title']
      : props.theme['color.greyExtraDarker']}; 
}
`;

export const IconNotification = styled.span`
  color: ${(props) => props.theme['color.text.light']};
  width: 24px;
  height: 24px;
`;

export const HeaderMenuButton = styled(Button)`
  display: none;
  margin-right: 6px;
  position: relative;
  left: -4px;

  @media (max-width: ${(props) => props.theme['media.tablet']}px) {
    display: block;
  }
`;
